import React from "react";
import useSiteContent from "@/lib/useSiteContent";
import { MODULE_ICONS } from "./_shared";

/**
 * `id="features"` is a contract: it is one of the registry's ANCHORS
 * (backend/modules/site_content/registry.py), the ids a `#…` navigation link may target.
 */
export default function EcosystemFeatures() {
  const { text } = useSiteContent();
  const features = [
    { id: "practice", title: text("ecosystem.practice"), body: text("feature.practice.text") },
    { id: "journeys", title: text("ecosystem.journeys"), body: text("feature.journeys.text") },
    { id: "ai", title: text("ecosystem.ai"), body: text("feature.ai.text") },
    { id: "telehealth", title: text("ecosystem.telehealth"), body: text("feature.telehealth.text") },
    { id: "automations", title: text("ecosystem.automations"), body: text("feature.automations.text") },
    { id: "payments", title: text("ecosystem.payments"), body: text("feature.payments.text") },
    { id: "insights", title: text("ecosystem.insights"), body: text("feature.insights.text") },
    { id: "courses", title: text("ecosystem.courses"), body: text("feature.courses.text") },
  ];
  return (
    <section id="features" className="py-28 lg:py-36 bg-sol-ivory">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <div className="text-xs uppercase tracking-[0.24em] text-sol-gold mb-4">
            {text("ecosystem.eyebrow")}
          </div>
          <h2 className="font-display text-4xl lg:text-5xl text-sol-midnight leading-tight">
            {text("ecosystem.titleA")}
            <br />
            <span className="italic text-sol-midnight/70">
              {text("ecosystem.titleB")}
            </span>
          </h2>
          <p className="mt-6 text-sol-midnight/60 text-lg leading-relaxed">
            {text("ecosystem.subtitle")}
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((f) => {
            const Icon = MODULE_ICONS[f.id];
            return (
              <div
                key={f.id}
                data-testid={`feature-${f.id}`}
                className="bg-white border border-sol-midnight/5 rounded-2xl p-8 hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300"
              >
                <Icon className="w-7 h-7 text-sol-gold mb-5" strokeWidth={1.4} />
                <h3 className="font-sol font-semibold text-lg mb-3 text-sol-midnight">{f.title}</h3>
                <p className="text-sm text-sol-midnight/60 leading-relaxed">{f.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
